import sleep from "sleep-promise";
import { createLogger } from "@/utils/log";
import { Router } from "../router";
import { AgentStore } from "@/app_store/agent_store";

const PING_INTERVAL_MS = 5_000;
const PONG_TIMEOUT_MS = 30_000;
const LOG = createLogger("agent");

export const router = new Router<AgentStore>();
router.producer(async (ctx) => {
    while (true) {
        await sleep(PING_INTERVAL_MS);
        const pong = await Promise.race([
            ctx.request({ type: "ping" }),
            sleep(PONG_TIMEOUT_MS).then(() => null),
        ]);
        if (!pong) {
            LOG("pong timeout — closing");
            ctx.closeSocket();
            break;
        }
    }
});
